export default "__VITE_ASSET__qPlFlzJP__"